// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { DeviceUtils } from '../util/device-utils';

@Injectable({ providedIn: 'root' })
export class TouchService {

  public init(): void {
    if (DeviceUtils.isTouch()) {
      this.addStyleClasses();
      this.disableZoomGestureOnTouchDevices();
      this.disableTouchContextMenu();
    }
  }

  private addStyleClasses(): void {
    if (DeviceUtils.isTouch()) {
      document.body.className += ` touch`;
    }
    if (DeviceUtils.isAndroid()) {
      document.body.className += ` android`;
    }
    if (DeviceUtils.isIos()) {
      document.body.className += ` ios`;
    }
  }

  private disableZoomGestureOnTouchDevices(): void {
    document.addEventListener(
      'touchmove',
      (event: any) => {
        if (event.scale !== 1 && event.target.id !== `main-scene-canvas`) {
          event.preventDefault();
        }
      },
      true
    );
  }

  private disableTouchContextMenu(): void {
    if (!DeviceUtils.isTouch()) {
      return;
    }
    document.addEventListener(
      `contextmenu`,
      (event) => {
        event.stopImmediatePropagation();
        event.preventDefault();
      },
      true
    );
  }
}
